import Vue from 'vue'
import url from "../utils/UrlApi"

Vue.filter('YearDate', function (str) {
    if (str) {
        var d = new Date(str)
        var year = d.getFullYear()
        var month = d.getMonth() + 1
        var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
        var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
        var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + '  ' + hour + ':' + minutes + ':' + seconds
    } else {
        return ''
    }
})

Vue.filter('imgUrl', function (id, type) {
    return url.imgUrl + '?id=' + id + '&type=' + type + '&code=1' + '&token=' + localStorage.getItem('token')
})
